'use client'

import * as Sentry from '@sentry/nextjs'
import { useEffect, useRef, useState } from 'react'

export const useWidth = () => {
  const ref = useRef(null)
  const [width, setWidth] = useState(0)

  useEffect(() => {
    try {
      const resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          // Assuming you only want to track the width
          setWidth(entry.contentRect.width)
        }
      })

      if (ref.current) {
        resizeObserver.observe(ref.current)
      }

      return () => {
        if (ref.current) {
          // eslint-disable-next-line react-hooks/exhaustive-deps
          resizeObserver.unobserve(ref.current)
        }
      }
    } catch (error) {
      Sentry.captureException(error)
    }
  }, [ref])

  return { ref, width }
}
